<template>
  <hm-col :id="$attrs['id']" :grid="true" cols="12">
    <hm-input-money :value="value.amount"
                    :currency="hotelSettings.details.currency"
                    :disabled="true"
                    :label="$t('folios.transactionSplit.amount')"
                    name="amount"
                    cols="4 12@mobile" />
    <hm-input-money v-model="split.amount"
                    :min="value.amount < 0 ? value.amount : 0"
                    :max="value.amount >= 0 ? value.amount : 0"
                    :currency="hotelSettings.details.currency"
                    :label="$t('folios.transactionSplit.amountSplit')"
                    name="amount"
                    cols="4 12@mobile" />
    <hm-input-money :value="value.amount - split.amount"
                    :currency="hotelSettings.details.currency"
                    :disabled="true"
                    :label="$t('folios.transactionSplit.amountRemaining')"
                    class="hidden@mobile"
                    name="amount"
                    cols="4 12@mobile" />
  </hm-col>
</template>


<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import {
  isArray,
  join,
  isNil,
  isEmpty,
  groupBy,
  values,
  head,
  cloneDeep,
  concat,
  unionBy,
  reverse,
  sortBy,
  last,
  isNumber,
  toNumber,
  get,
} from 'lodash';
import uuid from 'uuid';
import NotificationMixin from '../../../mixins/NotificationMixin';
import FilterMixin from '../../../mixins/FilterMixin';
import HmInput from '../inputs/HmInput';
import HmInputDate from '../inputs/HmInputDate';
import HmInputMoney from '../inputs/HmInputMoney';
import HmInputToggle from '../inputs/HmInputToggle';
import HmCardInner from '../layout/HmCardInner';

export default {
  name: 'TransactionEditor',
  components: { HmCardInner, HmInputToggle, HmInputMoney, HmInputDate, HmInput },
  mixins: [HotelmeisterMixin, NotificationMixin, FilterMixin],

  props: {
    transaction: {
      type: Object,
      required: false,
      default: null,
    },
    reservation: {
      type: Object,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      editItemAmount: true,
      value: {
        id: uuid.v4(),
        businessDate: this.$moment().format('YYYYMMDD'),
        code: null,
        label: null,
        comment: null,
        itemCount: 1,
        realItemCount: 1,
        itemAmount: 0,
        amount: 0,
        chargePeriod: null,
        firstDateOfRatePlan: false,
        ratePlanNumberOfNights: 1,
        takeAway: null,
        discountTransaction: null,
        transactionReferenceNumber: null,
        calculationDetails: {
          numAdults: 0,
          numChildren: 0,
          childAgeCategories: { },
          roomNumber: null,
          roomTypeId: null,
          numCityTaxOverrides: null,
        },
      },
      split: {
        amount: null,
      },
    };
  },

  computed: {
  },

  watch: {
  },

  created: function () {
    if (!isNil(this.transaction)) {
      const tmp = cloneDeep(this.transaction);
      this.split.amount = Math.round(tmp.amount / 2 * 100) / 100;
      this.value = tmp;
    } else {
      this.reInitTransaction();
    }
  },

  methods: {
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';
</style>



// WEBPACK FOOTER //
// src/components/lib/folios/TransactionSplit.vue